import React from 'react';
import banking from '../../img/png/com_banking.png';
import auto from '../../img/png/com_auto.png';
import fm from '../../img/png/com_fm.png';
import lux from '../../img/png/com_lux.png';
import { IoIosAnalytics } from 'react-icons/io';
import { BiTargetLock } from 'react-icons/bi';
import { AiOutlineCheckCircle } from 'react-icons/ai';

const MenuCommercial = ({ isActive }) => {
  return (
    <>
      <div className={`menu_commercial ${isActive}`}>
        <div className='menu_commercial_container d-flex-row gap-3'>
          <div className='menu_commercial_container_left d-flex-col align-items-center gap-3'>
            <div className='d-flex-row gap-2 align-items-center justify-content-between'>
              <div className='com_banner d-flex-col align-items-center justify-content-center gap-1'>
                <h3 className='text-subtitle'>Banking</h3>
                <img src={banking} alt='banking img' />
              </div>

              <div className='com_banner d-flex-col align-items-center justify-content-center gap-1'>
                <h3 className='text-subtitle'>Luxury</h3>
                <img src={lux} alt='lux img' />
              </div>
            </div>
            <div className='d-flex-row gap-2 align-items-center justify-content-between'>
              <div className='com_banner d-flex-col align-items-center justify-content-center gap-1'>
                <h3 className='text-subtitle'>Automotive</h3>
                <img src={auto} alt='auto img' />
              </div>
              <div className='com_banner d-flex-col align-items-center justify-content-center gap-1'>
                <h3 className='text-subtitle'>FMCG</h3>
                <img src={fm} alt='fmcg img' />
              </div>
            </div>
            <p className='text-gray'>
              We successfully work with hundreds of organisations across a broad
              spectrum of verticals. <br /> Our technology enables us to unlock
              the full online potential of global brands with the ability to
              detect and learn about the affinities of consumers towards any
              topic.
            </p>
          </div>
          <div className='menu_commercial_container_line'></div>
          <div className='menu_commercial_container_right d-flex-col'>
            {/* <h3>Markets & Products</h3> */}
            <div className='d-flex-col gap-2'>
              <div className='title d-flex-row align-items-center gap-2'>
                <span>
                  <IoIosAnalytics />
                </span>
                <h3 className='text-subtitle'>
                  Applications for Existing <br /> Markets & Products
                </h3>
              </div>
              <div className='bullet d-flex-col gap-1'>
                <div className=' d-flex-row align-items-center gap-1'>
                  <AiOutlineCheckCircle />
                  <p className='text-gray'>
                    Analyze the engagement of consumers against any subject.
                  </p>
                </div>
                <div className=' d-flex-row align-items-center gap-1'>
                  <AiOutlineCheckCircle />
                  <p className='text-gray'>
                    Understand key drivers and barriers leading consumers to
                    brands.
                  </p>
                </div>
                <div className=' d-flex-row align-items-center gap-1'>
                  <AiOutlineCheckCircle />
                  <p className='text-gray'>
                    Enhance viewer engagement, performance & attribution with
                    Smart-Ads.
                  </p>
                </div>
              </div>
            </div>
            <div className='d-flex-col gap-2'>
              <div className='title d-flex-row align-items-center gap-2'>
                <span>
                  <BiTargetLock />
                </span>
                <h3 className='text-subtitle'>
                  Applications for <br /> New Markets & Products
                </h3>
              </div>
              <div className='bullet d-flex-col gap-1'>
                <div className='d-flex-row align-items-center gap-1'>
                  <AiOutlineCheckCircle />
                  <p className='text-gray'>
                    Reach consumer bases with anonymised behavioural insights.
                  </p>
                </div>
                <div className=' d-flex-row align-items-center gap-1'>
                  <AiOutlineCheckCircle />
                  <p className='text-gray'>
                    Use AI to dynamically adjust Ad placement & targeting
                    coverage.
                  </p>
                </div>
                <div className=' d-flex-row align-items-center gap-1'>
                  <AiOutlineCheckCircle />
                  <p className='text-gray'>First Party Data Enrichment.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MenuCommercial;
